module.exports = __webpack_public_path__ + "img/logo.956e4d64.svg";